<template>
  <div>
    <Filtro
      @clientesRuraisFiltrados="atualizarFiltro"
      :redirectToCadastroEdicao="redirectToCadastroEdicao"
    />
    <div class="card mt-3">
      <div class="card-body position-relative">
        <div v-if="loadingTabela" class="overlay-spinner">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>

        <Grid
          :items="items"
          :filtro="filtro"
          @editarItem="editarItem"
          :default-mensagem="mensagemGrid"
          @clientesRuraisFiltrados="atualizarFiltro"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "@/components/astec/filtro";
import Grid from "@/components/astec/gridClienteRural";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { ClienteRuralService } from "@/services/astec/clienteRural";
import { paginacaoClientesRuraisHelper } from "@/store/helpers/vuex/astec";

export default {
  mixins: [clienteRuralMixin],

  components: {
    Filtro,
    Grid
  },

  computed: {
    ...paginacaoClientesRuraisHelper({
      state: ["currentPage", "pageSize", "total"],
      getters: ["currentPage", "pageSize", "total"],
      actions: []
    }).computed
  },

  data() {
    return {
      filtro: {},
      items: {
        dados: [],
        total_registros: 0,
        pagina_atual: null
      },
      loadingTabela: false,
      mensagemGrid: "Nenhum cliente rural encontrado."
    };
  },

  created() {
    this.$tools.fecharMenu();
  },

  methods: {
    ...paginacaoClientesRuraisHelper({
      actions: ["resetarPaginacao", "setPage", "setTotal", "setPageSize"]
    }).methods,

    redirectToCadastroEdicao() {
      this.$store.commit("CLIENTE_RURAL_ASTEC", "");
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    },

    async atualizarFiltro(filtro, callback) {
      if (filtro === null) {
        this.items = {
          dados: [],
          total_registros: 0,
          pagina_atual: null
        };

        await this.resetarPaginacao();
        this.$store.commit("PARAMETROS_FILTRO_CLIENTE_RURAL_ASTEC", null);

        callback?.();
        return;
      }

      try {
        this.loadingTabela = true;
        const page = filtro?.page || this.currentPage || 1;
        const perPage = this.pageSize;

        this.setPage(page);

        this.filtro = {
          ...filtro,
          page
        };

        const response = await ClienteRuralService.buscarClientesRurais(
          this.filtro,
          page,
          perPage
        );

        if (response?.dados) {
          this.items = response;

          if (response.total_registros) {
            this.setTotal(response.total_registros);
          }
        } else {
          this.items = {
            dados: [],
            total_registros: 0,
            pagina_atual: page
          };
        }

        callback?.();
      } catch (err) {
        this.items = {
          dados: [],
          total_registros: 0,
          pagina_atual: null
        };
      } finally {
        this.loadingTabela = false;
      }
    },

    async editarItem(item) {
      this.$store.commit("CLIENTE_RURAL_ASTEC", item);
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    }
  }
};
</script>

<style>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}

.overlay-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
</style>
